import { useCallback } from 'react'
import { buildUserAndPendingMessages } from './helpers/buildUserAndPendingMessages'
import { priorMessagesWithoutPending } from './helpers/priorMessagesWithoutPending'
import { scheduleCompletionUpdate } from './helpers/scheduleCompletionUpdate'
import { createThreadAbortController } from './helpers/threadAbortController'

/** @param {object} m @param {ReturnType<typeof import('./useExchangeVersionActions').useExchangeVersionActions>} v */
export function useSendEditVersionAction(m, v) {
  const { chatAbortRef, setMessagesByThreadId } = m
  const {
    getNextQueryVersionIndex,
    setExchangeActiveQueryVersion,
    setExchangeActiveAnswerVersion,
  } = v
  const handleSendEditVersion = useCallback(
    ({ threadId, exchangeId, text }) => {
      const trimmed = String(text ?? '').trim()
      if (!trimmed) return
      const tid = threadId
      chatAbortRef.current?.abort()
      const controller = createThreadAbortController(tid)
      chatAbortRef.current = controller
      const { signal } = controller
      const nextIndex = getNextQueryVersionIndex(tid, exchangeId)
      setMessagesByThreadId((prev) => {
        const priorMessages = priorMessagesWithoutPending(prev, tid)
        const now = Date.now()
        const { userMsg, pendingId, pendingAssistant } = buildUserAndPendingMessages({
          trimmed,
          exchangeId,
          versionIndex: nextIndex,
          now,
        })
        const apiMessages = [...priorMessages, userMsg].map((msg) => ({
          role: msg.role,
          content: msg.text,
        }))
        scheduleCompletionUpdate({ tid, pendingId, signal, setMessagesByThreadId, apiMessages })
        return { ...prev, [tid]: [...priorMessages, userMsg, pendingAssistant] }
      })
      setExchangeActiveQueryVersion(exchangeId, nextIndex)
      setExchangeActiveAnswerVersion(exchangeId, 0)
    },
    [getNextQueryVersionIndex, setExchangeActiveAnswerVersion, setExchangeActiveQueryVersion, chatAbortRef, setMessagesByThreadId],
  )
  return { handleSendEditVersion }
}
